import { useState } from "react";
import * as Icons from "lucide-react";
import { Link } from "react-router-dom";
import BlockShell from "./BlockShell";

// "Follow everywhere" hub: a grid of platform / social / press tiles with lucide icons.
const LinkHubBlock = ({ block }) => {
  const cfg = block.config || {};
  const allLinks = (cfg.links || []).filter((l) => l.url && l.label);
  const collapsedShow = Number(cfg.collapsed_show) || 0;
  const [expanded, setExpanded] = useState(false);
  const links = collapsedShow && !expanded ? allLinks.slice(0, collapsedShow) : allLinks;
  if (!links.length) return null;
  const cols = Number(cfg.columns) || 4;
  const gridCls = cols >= 4 ? "lg:grid-cols-4" : cols === 2 ? "lg:grid-cols-2" : "lg:grid-cols-3";
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-12 py-8" data-testid="fest-link-hub">
      <BlockShell block={block} accent={cfg.accent || "#2E5C55"}>
        {cfg.intro && <p className="text-base text-[#5C5C5C] leading-relaxed mb-6 max-w-3xl">{cfg.intro}</p>}
        <div className={`grid gap-3 grid-cols-1 sm:grid-cols-2 ${gridCls} [&>*]:min-w-0`}>
          {links.map((l, i) => {
            const Icon = Icons[l.icon] || Icons.Link;
            const color = l.color || cfg.accent || "#2E5C55";
            const external = /^https?:\/\//i.test(l.url) || /^mailto:/i.test(l.url);
            const inner = (
              <>
                <span className="h-11 w-11 rounded-xl flex items-center justify-center text-white shrink-0 transition-transform group-hover:scale-105" style={{ background: color }}><Icon className="h-5 w-5" /></span>
                <span className="min-w-0 flex-1">
                  <span className="block font-extrabold text-[#1A1A1A] leading-tight truncate">{l.label}</span>
                  {l.sublabel && <span className="block text-xs text-[#5C5C5C] mt-0.5 truncate">{l.sublabel}</span>}
                </span>
                <Icons.ArrowUpRight className="h-4 w-4 text-[#5C5C5C] shrink-0 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </>
            );
            const cls = "group min-w-0 flex items-center gap-3 rounded-2xl border border-[#E2E0DC] bg-white p-3.5 shadow-sm hover:shadow-lg hover:-translate-y-0.5 transition-all";
            return external
              ? <a key={i} href={l.url} target="_blank" rel="noopener noreferrer" className={cls} data-testid={`link-hub-${i}`}>{inner}</a>
              : <Link key={i} to={l.url} className={cls} data-testid={`link-hub-${i}`}>{inner}</Link>;
          })}
        </div>
        {collapsedShow && allLinks.length > collapsedShow ? (
          <button type="button" onClick={() => setExpanded(!expanded)} className="mt-4 inline-flex items-center gap-1 text-sm font-bold underline-offset-2 hover:underline" style={{ color: cfg.accent || "#2E5C55" }} data-testid="link-hub-toggle">
            {expanded ? "Show less" : `Show all ${allLinks.length} links`} <Icons.ChevronDown className={`h-4 w-4 transition-transform ${expanded ? "rotate-180" : ""}`} />
          </button>
        ) : null}
      </BlockShell>
    </section>
  );
};

export default LinkHubBlock;
